import * as React from "react";
const SvgFiRrJam = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-jam_svg__a)">
      <path
        fill="#062147"
        d="M23.818 7.1A4.78 4.78 0 0 0 20 4.078V3a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v1.078c-3.776.457-5.682 5.347-2 6.79V18a6.006 6.006 0 0 0 6 6h8a6.006 6.006 0 0 0 6-6v-7.13a2.91 2.91 0 0 0 1.818-3.77M20 18a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-7.139c.895-.068 1.658-1.313 2.556-.7a4.06 4.06 0 0 0 4.89 0 .95.95 0 0 1 1.11 0 4.06 4.06 0 0 0 4.89 0c.9-.619 1.657.627 2.554.7zm1.831-9.346c-.37.618-1.556.281-2.052-.07a2.945 2.945 0 0 0-3.557 0 2.03 2.03 0 0 1-2.443 0 2.945 2.945 0 0 0-3.557 0 2.03 2.03 0 0 1-2.443 0 2.945 2.945 0 0 0-3.557 0c-.84.616-2.535.654-2.165-.791A2.86 2.86 0 0 1 5 6h10a1 1 0 1 0 0-2H6V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1c2.217.008 3.413 1.651 2.831 2.654"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-jam_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrJam;
